module.exports = __webpack_public_path__ + "ca858dddbb72c53cfeedcb71886d74da.svg";